import { render, staticRenderFns } from "./OpenerButton.vue?vue&type=template&id=45ee8fa4"
import script from "./OpenerButton.vue?vue&type=script&lang=js"
export * from "./OpenerButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports